import React, { ReactElement } from 'react';
import { TIconProps } from './Icons.types';

function ShareIcon({
  height = 20,
  width = 20,
  ...restProps
}: TIconProps): ReactElement {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95181 1.63291V9.00543C5.95181 9.26906 6.16488 9.45996 6.45761 9.45996C6.75035 9.45996 6.96342 9.26906 6.96342 9.00543V1.57666L8.5997 3.04651C8.69643 3.134 8.82225 3.18173 8.9544 3.18173C9.08717 3.18173 9.21299 3.134 9.31036 3.04651C9.40709 2.95958 9.46083 2.84594 9.46083 2.7272C9.46083 2.60845 9.40709 2.49482 9.31036 2.40789L6.78133 0.135224C6.68459 0.0482941 6.55814 0 6.426 0C6.29386 0 6.16741 0.0482941 6.07067 0.135224L3.54165 2.40789C3.44428 2.49482 3.39117 2.60845 3.39117 2.7272C3.39117 2.84594 3.44428 2.95958 3.54165 3.04651C3.64344 3.13798 3.80214 3.19082 3.97727 3.19082C4.08475 3.19082 4.18718 3.17093 4.31553 3.10332L5.95181 1.63291ZM0 15.5152C0 15.7964 0.24892 16 0.590909 16H12.4091C12.7518 16 13 15.7964 13 15.5152V5.81818C13 5.53758 12.7518 5.33333 12.4091 5.33333H9.45455C9.11182 5.33333 8.86364 5.53758 8.86364 5.81818C8.86364 6.09939 9.11182 6.30303 9.45455 6.30303H11.8182V15.0303H1.18182V6.30303H3.54545C3.88744 6.30303 4.13636 6.09939 4.13636 5.81818C4.13636 5.53758 3.88744 5.33333 3.54545 5.33333H0.590909C0.24892 5.33333 0 5.53758 0 5.81818V15.5152Z"
        fill="#333333"
      />
    </svg>
  );
}

export default ShareIcon;
